import { type RouteRecordRaw } from "vue-router";

import { APP_SETTINGS_SUBSCRIPTIONS_ROUTES as SUBS } from "@/Generated/Routes/paths";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, isPatientGuard } from "@/Router/guards";

const subscriptions: RouteRecordRaw[] = [
  {
    ...SETTINGS.subscriptions.root,
    component: () => import("@/Views/settings/subscriptions/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscriptions-title",
    },
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...SUBS.payment.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.payment_methods",
    },
    component: () => import("@/Views/settings/subscriptions/views/Payment/index.vue"),
  },
  {
    ...SUBS.payment.add.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.payment_methods",
    },
    component: () => import("@/Views/settings/subscriptions/views/Payment/Add/index.vue"),
  },
  {
    ...SUBS.plan.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.choose_your_plan",
    },
    component: () => import("@/Views/settings/subscriptions/views/Plan/index.vue"),
  },
  {
    ...SUBS.privatePlan.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.promo_code.insert_promotional_code",
    },
    component: () => import("@/Views/settings/subscriptions/views/Plan/index.vue"),
  },
  {
    ...SUBS.promoCode.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.promo_code.insert_promotional_code",
    },
    component: () => import("@/Views/settings/subscriptions/views/PromoCode.vue"),
  },
  {
    ...SUBS.cancel.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.cancel",
    },
    component: () => import("@/Views/settings/subscriptions/views/Cancel/index.vue"),
  },
  {
    ...SUBS.cancel.reason.root,
    meta: {
      sidebar: false,
      i18nTitle: "settings.subscription.patient.cancel",
    },
    component: () => import("@/Views/settings/subscriptions/views/Cancel/CancelReason.vue"),
  },
  {
    ...SUBS.sessions.root,
    meta: {
      sidebar: false,
      i18nTitle: "sessions_payments_records",
    },
    component: () => import("@/Views/settings/subscriptions/views/Sessions/index.vue"),
  },
  {
    ...SUBS.extra_sessions.root,
    component: () => import("@/Views/settings/subscriptions/views/ExtraSessions/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "user.settings.subscription.sessions_extra.title",
    },
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
];

export default subscriptions;
